import React, { createContext, useEffect, useMemo, useState } from 'react';
import { Route, Routes } from 'react-router-dom';

import Dashboard from './Dashboard/Dashboard';
import Entities from './Entities/Entities';
import Loans from './Loans/Loans';
import Profile from './Profile/Profile';
import ChangePassword from 'scenes/Public/ChangePassword/ChangePassword';
import { useGetUserLoggin } from 'services/user/querys';
import NotFound from 'scenes/404';
import { LoadScript } from '@react-google-maps/api';
import { GOOGLE_API_KEY, INTERCOM_APP_ID, BORROWER_ONBOARDING_URL } from '@common/config/environments';
import Intercom from '@intercom/messenger-js-sdk';
import { updateModalContextInSentry } from 'sentry/contexts/modalContext';
import { updateUserContextInSentry } from 'sentry/contexts/userContext';

export const EntitiesViewContext = createContext<{ visible: boolean; setHandlerVisible: any } | {}>({});
export const LoansViewContext = createContext<{ visible: boolean; setHandlerVisible: any; lockedDeadLayout: boolean; setLockedDeadLayout: any } | {}>({});
export const ProfileViewContext = createContext<{ visible: boolean; setHandlerVisible: any } | {}>({});
export const TaskOpenModalContext = createContext<{ value: string; setHandler: any } | {}>({});

const RedirectToOnboarding = () => {
  React.useEffect(() => {
    window.location.href = `${BORROWER_ONBOARDING_URL}/`;
  }, []);
  return null;
};

const Private = () => {

  const { data: user, error } = useGetUserLoggin();

  const libraries: any = useMemo(() => ['places'], []);

  const [taskOpenModal, setTaskOpenModal] = useState<any>();
  const [entitiesView, setEntitiesView] = useState<boolean>(false);
  const [loansView, setLoansView] = useState<boolean>(false);
  const [profileView, setProfile] = useState<boolean>(false);
  const [lockedDeadLayout, setLockedDeadLayout] = useState<boolean>(false);

  useEffect(() => {
    if (error?.message.includes('Unauthorized'))
      logout();
  }, [error]);

  const logout = () => {
    localStorage.removeItem('token');
    window.dispatchEvent(new Event("storage"));
    window.location.href = '/login';
    
  }

  if (INTERCOM_APP_ID && user && user.name) {
    Intercom({
      app_id: INTERCOM_APP_ID,
      user_id: user._id,
      name: user.name,
      email: user.email,
      created_at: user.createdAt
    });
  }

  useEffect(() => {
    updateUserContextInSentry(user);
  }, [user?._id]);

  return (
    <EntitiesViewContext.Provider value={{ visible: entitiesView, setHandlerVisible: setEntitiesView }}>
      <LoansViewContext.Provider value={{ visible: loansView, setHandlerVisible: setLoansView, lockedDeadLayout, setLockedDeadLayout }}>
        <ProfileViewContext.Provider value={{ visible: profileView, setHandlerVisible: setProfile }}>
          <TaskOpenModalContext.Provider value={{ value: taskOpenModal, setHandler: (key: string | undefined) => {
            updateModalContextInSentry(key);
            setTaskOpenModal(key);
          } }}>
            <div className="Private">
              <LoadScript
                googleMapsApiKey={GOOGLE_API_KEY || ''}
                loadingElement={<></>}
                libraries={libraries}
              >
                <Routes>
                  <Route path="*" element={<Dashboard />} />
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/onboarding" element={<RedirectToOnboarding />} />
                  <Route path="/home/:loanId" element={<Dashboard />} />
                  <Route path="/profile" element={<Dashboard />} />
                  <Route path="/change-password/:token" element={<ChangePassword />} />
                </Routes>

                {entitiesView && <Entities EntitiesViewContext={EntitiesViewContext} />}
                {loansView && <Loans LoansViewContext={LoansViewContext} />}
                <Profile 
                  ProfileViewContext={ProfileViewContext} 
                  EntitiesViewContext={EntitiesViewContext} 
                  LoansViewContext={LoansViewContext} 
                />
              </LoadScript>
            </div>
          </TaskOpenModalContext.Provider>
        </ProfileViewContext.Provider>
      </LoansViewContext.Provider>
    </EntitiesViewContext.Provider>
  );
};
export default Private;
